import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getSocket } from '../socket';
import { playSound } from '../utils/soundAlerts';
import API from '../api';

// ── 인사기록카드 작성요청 실시간 알림 모달 ──────────────────────────────
// 인사관리(HRManagement.js) 직원현황 상세보기에서 관리자가 "작성요청" 버튼을 누르면
// (backend/routes/hr.js의 POST /employees/:userId/request-info 가 'hr:info-request:new'
// 이벤트를 대상 직원의 개인 소켓 room(user:<아이디>)으로 쏴준다), 지금 어느 화면을 보고
// 있든 바로 모달로 알려준다. TaskRequestAlert.js와 동일한 패턴.
//
// 요청 시점에 로그인되어 있지 않았던 경우를 위해, 마운트 시 GET /mypage/info-request/pending
// 으로 미확인 요청이 있는지도 한 번 확인한다(다음 로그인 시 알림이 뜨도록).
export default function HrInfoRequestAlert() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [incoming, setIncoming] = useState(null); // { id, requested_by, requested_at }

  useEffect(() => {
    if (!user) return;
    // 로그인 직후(또는 이 컴포넌트가 처음 마운트될 때) 이미 대기중인 작성요청이 있는지 확인.
    API.get('/mypage/info-request/pending')
      .then(res => { if (res.data && !document.fullscreenElement) { setIncoming(res.data); playSound('task'); } })
      .catch(() => {});

    const socket = getSocket();
    if (!socket) return;
    const onNew = (payload) => {
      if (document.fullscreenElement) return; // 생산전광판 전체화면 중에는 방해하지 않음
      setIncoming(payload);
      playSound('task');
    };
    socket.on('hr:info-request:new', onNew);
    return () => socket.off('hr:info-request:new', onNew);
  }, [user]);

  if (!incoming) return null;

  const ack = () => {
    if (incoming?.id) API.patch(`/mypage/info-request/${incoming.id}/ack`).catch(() => {});
  };

  // 작성하기 — 확인 처리 후 계정관리(마이페이지)로 이동, 추가정보 모달을 자동으로 연다.
  const goWrite = () => {
    ack();
    setIncoming(null);
    navigate('/mypage', { state: { openHrCard: true } });
  };

  // 닫기 — 확인 처리만 하고 그냥 닫는다.
  const handleClose = () => {
    ack();
    setIncoming(null);
  };

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:3000,
      display:'flex', alignItems:'center', justifyContent:'center' }}
      onClick={handleClose}>
      <div style={{ background:'#fff', borderRadius:14, width:400, maxWidth:'90vw', padding:'26px 24px 22px' }}
        onClick={e => e.stopPropagation()}>
        <div style={{ fontSize:12.5, fontWeight:700, color:'#b45309', marginBottom:8 }}>
          📇 인사기록카드 작성요청이 도착했습니다
        </div>
        <div style={{ fontSize:16.5, fontWeight:700, color:'#1a1a1a', marginBottom:8 }}>
          추가정보(주민등록등본, 통장사본)를 등록해 주세요
        </div>
        <div style={{ fontSize:13, color:'#666', marginBottom:4 }}>
          요청자 {incoming.requested_by || '-'}
        </div>
        <div style={{ display:'flex', gap:8, marginTop:20 }}>
          <button onClick={goWrite}
            style={{ flex:1, padding:'11px', background:'#b45309', color:'#fff', border:'none',
              borderRadius:8, fontSize:13, fontWeight:700, cursor:'pointer' }}>
            작성하기
          </button>
          <button onClick={handleClose}
            style={{ flex:1, padding:'11px', background:'#fff', color:'#555', border:'1px solid #ddd',
              borderRadius:8, fontSize:13, fontWeight:600, cursor:'pointer' }}>
            닫기
          </button>
        </div>
      </div>
    </div>
  );
}
